import { render, staticRenderFns } from "./bulletinBoard.vue?vue&type=template&id=c9443794&scoped=true&"
import script from "./bulletinBoard.vue?vue&type=script&lang=js&"
export * from "./bulletinBoard.vue?vue&type=script&lang=js&"
import style0 from "./bulletinBoard.vue?vue&type=style&index=0&id=c9443794&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9443794",
  null
  
)

export default component.exports